/**
 * The MONSTER stream's own state for one monster shot (spec 02 §5 attacks): Hidegons' fireball,
 * Drunk's bottle (out and back), Mighta's rock (it rolls every other pass), the Invader's laser.
 * Plain numbers and booleans only (06 R5).
 *
 * A shot is one of the C64's software sprites (types $28 fireball, $2A rock, $2C bottle, $32 laser)
 * and lives in whole cells, as a bubble does: `col` [$DC,x] is the playfield column, `row` [$EE,x]
 * is the playfield row + 3. The shot's `x`, `y` are kept at 8col + $14, 8row + $15 (VIC frame).
 */

export interface ProjectileMotion {
  /** Main-loop passes it has flown (the clock's do not count). */
  age: number;
  /** Cell column [$DC,x] and row [$EE,x] (row = playfield tile row + 3). */
  col: number;
  row: number;
  /**
   * The picture [$A9C4,x]: the fireball's 0..3 (bit 1 facing right, bit 0 its flicker), the rock's
   * roll 0/1 (it moves on the pass that makes it 1 going left, 0 going right), the bottle's spin 0..3.
   */
  anim: number;
  /** The bottle's column to come back to [$AA0C,x = the column it left from]. */
  home: number;
  /** -1 in flight; else passes since it stopped (a wall, a kill, the floor, the level clear). */
  end: number;
  /** How it went: true bursts (type $3A: the rock crumbling, the laser's kill, the clear), false vanishes ($38). */
  burst: boolean;
}

export function initialProjectileMotion(): ProjectileMotion {
  return { age: 0, col: 0, row: 0, anim: 0, home: 0, end: -1, burst: false };
}
